// extracted by mini-css-extract-plugin
export var splitContainer = "splitContainer-module--split-container--MTIeJ";
export var splitContainerColumnReverse = "splitContainer-module--split-container--column-reverse--+nPIU";
export var splitContainer__primary = "splitContainer-module--split-container__primary--Bci8e";
export var splitContainer__secondary = "splitContainer-module--split-container__secondary--br53y";
export var splitContainer__secondaryPinned = "splitContainer-module--split-container__secondary--pinned--RKuUc";